import PropTypes from "prop-types"
import React from "react"
import { Link } from "react-router-dom"
import { isEmpty, map } from "lodash"
import { Badge, Card, CardBody, Row, Col } from "reactstrap"
import { seasonPasstSatusTypes } from "../../constants/common"
import { currency, dateformat } from "config"
import moment from "moment"
import { convertUtcToLocal } from "helpers/util"

const getColor = status => {
  if (status == seasonPasstSatusTypes.Removed || status == seasonPasstSatusTypes["Not-Available"]) {
    return "danger"
  } else if (
    status == seasonPasstSatusTypes.Available ||
    status == seasonPasstSatusTypes.Approved
  ) {
    return "success"
  } else if (status == seasonPasstSatusTypes.Blacklist) {
    return "dark"
  } else {
    return "warning"
  }
}

const getAvatarColor = status => {
  if (status == seasonPasstSatusTypes.Available || status == seasonPasstSatusTypes.Approved) {
    return "success"
  } else {
    return "danger"
  }
}

const getPendingChanges = (scheduled, field) => {
  if (scheduled) {
    const findObj = scheduled.find(el => el.updateField == field)

    if (findObj) {
      return findObj.updateData
    } else {
      return ""
    }
  }
  return ""
}

const getScheduleDate = (scheduled, field) => {
  if (!isEmpty(scheduled) && Array.isArray(scheduled)) {
    const findObj = (scheduled || []).find(el => el.updateField == field)
    if (findObj) {
      return convertUtcToLocal(findObj.dateScheduled)
    } else {
      return ""
    }
  }
  return ""
}

const checkPendingChanges = scheduled => {
  return (
    getPendingChanges(scheduled, "carParkTitle") != "" ||
    getPendingChanges(scheduled, "expiryDate") != "" ||
    getPendingChanges(scheduled, "pricing") != "" ||
    getPendingChanges(scheduled, "lots") != "" ||
    getPendingChanges(scheduled, "carParkShortCode") != ""
  )
}

const getPendingChangesDate = item => {
  if (getScheduleDate(item, "carParkTitle") != "") {
    return getScheduleDate(item, "carParkTitle")
  } else if (getScheduleDate(item, "expiryDate") != "") {
    return getScheduleDate(item, "expiryDate")
  } else if (getScheduleDate(item, "pricing") != "") {
    return getScheduleDate(item, "pricing")
  } else if (getScheduleDate(item, "lots") != "") {
    return getScheduleDate(item, "lots")
  } else if (getScheduleDate(item, "carParkShortCode") != "") {
    return getScheduleDate(item, "carParkShortCode")
  }
  return ""
}

const CardGrid = ({ data = [], openEdit }) => {
  return (
    <React.Fragment>
      {map(data, (item, key) => {
        const scheduled = item.scheduled

        return (
          <Col lg="4" xl="4" sm="6" key={key}>
            <a onClick={() => openEdit(item)}>
              <Card style={{ minHeight: 210 }}>
                <CardBody className="mb-1 pb-1">
                  <div className="d-flex">
                    <div className={"avatar-md me-2"}>
                      <span
                        className={`avatar-title rounded-circle font-size-16 ${
                          "bg-" + getAvatarColor(item?.status)
                        }`}
                        style={{ color: "#fff" }}
                      >
                        {item?.carParkShortCode || "CP"}
                      </span>
                    </div>

                    <div className="flex-grow-1 overflow-hidden">
                      <h5 className="text-truncate font-size-15">
                        <Link to={"#"} className="text-dark">
                          {item?.carParkTitle || ""}
                        </Link>
                        {getPendingChanges(scheduled, "carParkTitle") && (
                          <>
                            <Badge className={"bg-warning ms-4"}>Pending</Badge>{" "}
                            <span className="text-truncate font-size-12">
                              {getPendingChanges(scheduled, "carParkTitle")}
                            </span>
                          </>
                        )}
                      </h5>
                      <>
                        {Array.isArray(item?.vehicleType) ? (
                          <>
                            {item.vehicleType.map(e =>
                              (e?.lots || 0) > 0 ? (
                                <Row className="text-muted" key={e._id}>
                                  <Col md={3}>
                                    {(e?.vehicleType || "Car").toUpperCase()}
                                  </Col>
                                  <Col md={3}>
                                    {e?.lots || 0} lots
                                    {getPendingChanges(scheduled, "lots") && (
                                      <>
                                        <Badge className={"bg-warning  ms-4"}>
                                          Pending
                                        </Badge>{" "}
                                        <span>
                                          {getPendingChanges(scheduled, "lots")}
                                        </span>
                                      </>
                                    )}
                                  </Col>
                                  <Col md={6}>
                                    {` ${currency.SGD} ${parseFloat(
                                      e?.pricing || 0
                                    ).toFixed(2)} / ${e.pricingType || "hour"}`}
                                    {getPendingChanges(
                                      scheduled,
                                      "pricing"
                                    ) && (
                                      <>
                                        <Badge className={"bg-warning  ms-4"}>
                                          Pending
                                        </Badge>{" "}
                                        <span>
                                          {getPendingChanges(
                                            scheduled,
                                            "pricing"
                                          )}
                                          /
                                          {getPendingChanges(
                                            scheduled,
                                            "pricingType"
                                          )}
                                        </span>
                                      </>
                                    )}
                                  </Col>
                                </Row>
                              ) : null
                            )}
                          </>
                        ) : (item?.lots || 0) > 0 ? (
                          <Row className="text-muted">
                            <Col md={3}>CAR</Col>
                            <Col md={3}>
                              {item?.lots || 0} lots
                              {getPendingChanges(scheduled, "lots") && (
                                <>
                                  <Badge className={"bg-warning  ms-4"}>
                                    Pending
                                  </Badge>{" "}
                                  <span>
                                    {getPendingChanges(scheduled, "lots")}
                                  </span>
                                </>
                              )}
                            </Col>
                            <Col md={6}>
                              {` ${currency.SGD} ${parseFloat(
                                item?.pricing || 0
                              ).toFixed(2)} / ${item.pricingType || "hour"}`}
                              {getPendingChanges(scheduled, "pricing") && (
                                <>
                                  <Badge className={"bg-warning  ms-4"}>
                                    Pending
                                  </Badge>{" "}
                                  <span>
                                    {getPendingChanges(scheduled, "pricing")}/
                                    {getPendingChanges(
                                      scheduled,
                                      "pricingType"
                                    )}
                                  </span>
                                </>
                              )}
                            </Col>
                          </Row>
                        ) : null}
                      </>
                    </div>
                  </div>
                </CardBody>
                <div className="px-4 py-3 border-top">
                  <ul className="list-inline mb-0">
                    {item?.status != "Not-Applicable" && (
                      <li className="list-inline-item me-3">
                        <Badge className={"bg-" + getColor(item?.status)}>
                          {item?.status == "Available" ||
                          item?.status == seasonPasstSatusTypes.Approved
                            ? "Live"
                            : item?.status == seasonPasstSatusTypes.Pending
                            ? "Pending Live"
                            : item?.status}
                        </Badge>{" "}
                        {(item?.status == "Available" ||
                          item?.status == seasonPasstSatusTypes.Approved) && (
                          <i className="bx bx-calendar me-1" />
                        )}{" "}
                        {item?.status == "Available" ||
                        item?.status == seasonPasstSatusTypes.Approved
                          ? convertUtcToLocal(item?.liveDate || moment())
                          : ""}
                        {item?.status == seasonPasstSatusTypes.Pending && item?.liveDate
                          ? convertUtcToLocal(item?.liveDate)
                          : getScheduleDate(item?.scheduled, "status")}
                      </li>
                    )}

                    {item?.expiryDate && (
                      // <ul className="list-inline mb-0">
                      <li className="list-inline-item me-3">
                        <Badge className={"bg-muted"}>Expire</Badge>{" "}
                        <i className="bx bx-calendar me-1" />{" "}
                        {convertUtcToLocal(item?.expiryDate)}
                      </li>
                      // </ul>
                    )}
                    {checkPendingChanges(scheduled) && (
                      // <ul className="list-inline mb-0">
                      <li className="list-inline-item">
                        <Badge className={"bg-warning"}>Pending changes</Badge>{" "}
                        <i className="bx bx-calendar me-1" />{" "}
                        <span>{getPendingChangesDate(scheduled)}</span>
                      </li>
                      // </ul>
                    )}
                  </ul>
                </div>
              </Card>
            </a>
          </Col>
        )
      })}
    </React.Fragment>
  )
}

CardGrid.propTypes = {
  data: PropTypes.array,
  openEdit: PropTypes.func,
}

export default CardGrid
